import { useTranslation } from "react-i18next";
import "./Hero.css";
import Hero3DLogo from "./Hero3DLogo";

const STACK = ["React", "Node.js", "TypeScript", "Python", "PostgreSQL", "Docker", "AWS"];

export default function Hero() {
  const { t } = useTranslation();
  return (
    <section id="top" className="hero">
      <div className="container hero__inner">
        <div className="hero__content">
          <span className="hero__eyebrow">{t("hero.eyebrow")}</span>
          <h1 className="hero__title">{t("hero.title")}</h1>
          <p className="hero__subtitle">{t("hero.subtitle")}</p>
          <div className="hero__actions">
            <a href="#contato" className="btn btn--primary">
              {t("hero.cta_primary")}
            </a>
            <a href="#servicos" className="btn btn--secondary">
              {t("hero.cta_secondary")}
            </a>
          </div>

          <ul className="hero__badges" aria-label={t("hero.stack_aria")}>
            {STACK.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </div>

        <div className="hero__visual">
          <Hero3DLogo />
        </div>
      </div>
    </section>
  );
}
